import CircularProgress from "@mui/material/CircularProgress";

function Loader({ size, sx }) {
  return <CircularProgress color="primary" size={size || 40} sx={{ ...sx }} />;
}

export default Loader;
